import {enableProdMode, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {APP_CONFIG} from './app/shared/misc/inject-tokens';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {AppConfig} from './app/shared/model/app-config.model';
import {httpInterceptorProviders} from './app/http-interceptor-providers';
import {windowProviders} from './app/window-providers';
import {RxStompService} from './app/shared/service/rx-stomp.service';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {DecimalPipe, registerLocaleData} from '@angular/common';
import {provideAnimations} from '@angular/platform-browser/animations';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {routes} from './app/app.routes';
import {StoreModule} from '@ngrx/store';
import {reducers} from './app/shared/store/app.reducers';
import {EffectsModule} from '@ngrx/effects';
import {OfferEffects} from './app/shared/store/offer/offer.effects';
import {UserEffects} from './app/shared/store/user/user.effects';
import {AppComponent} from './app/app.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {CustomTranslateLoader} from './app/shared/misc/custom-translate-loader';
import {ReactiveFormsModule} from '@angular/forms';
// Angular requires manual import of all locales in use, it only knows en-US by default
// see https://angular.io/guide/i18n#i18n-pipes for further information
import localeDe from '@angular/common/locales/de';
import localeSl from '@angular/common/locales/sl';
import localeBs from '@angular/common/locales/bs';
import localeBg from '@angular/common/locales/bg';
import localeHr from '@angular/common/locales/hr';
import localeCs from '@angular/common/locales/cs';
import localeFr from '@angular/common/locales/fr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeMk from '@angular/common/locales/mk';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeSr from '@angular/common/locales/sr';
import localeSk from '@angular/common/locales/sk';
import localeEs from '@angular/common/locales/es';
import localeUk from '@angular/common/locales/uk';
import {
  PreloadAllModules,
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig
} from '@angular/router';
import {GalleryModule} from '@ks89/angular-modal-gallery';

const request = new XMLHttpRequest();
request.addEventListener('load', configListener);
request.addEventListener('error', configFailed);
request.open('GET', './assets/config/config.json');
request.send();

registerLocaleData(localeDe);
registerLocaleData(localeSl);
registerLocaleData(localeBs);
registerLocaleData(localeBg);
registerLocaleData(localeHr);
registerLocaleData(localeCs);
registerLocaleData(localeFr);
registerLocaleData(localeHu);
registerLocaleData(localeIt);
registerLocaleData(localeMk);
registerLocaleData(localePl);
registerLocaleData(localePt);
registerLocaleData(localeRo);
registerLocaleData(localeSr);
registerLocaleData(localeSk);
registerLocaleData(localeEs);
registerLocaleData(localeUk);

export const conditionalImports = [];

function configListener(response: any) {
  try {
    const configuration: AppConfig = JSON.parse(response.target.responseText);

    if (configuration.production) {
      enableProdMode();
    } else {
      conditionalImports.push(StoreDevtoolsModule.instrument());
    }

    bootstrapApplication(AppComponent, {
      providers: [
        provideZoneChangeDetection(),provideRouter(
          routes,
          withPreloading(PreloadAllModules),
          withRouterConfig({ onSameUrlNavigation: 'reload'}),
          withInMemoryScrolling({anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'})
        ),
        importProvidersFrom(
          TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useClass: CustomTranslateLoader,
            }
          }),
          ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
          BrowserModule,
          ClipboardModule,
          GalleryModule, //must be provided here
          StoreModule.forRoot(reducers, {
            runtimeChecks: {
              strictStateImmutability: false,
              strictActionImmutability: false
            }
          }),
          EffectsModule.forRoot([
            OfferEffects,
            UserEffects
          ]), ...conditionalImports),
        httpInterceptorProviders,
        windowProviders,
        RxStompService,
        { provide: APP_CONFIG, useValue: configuration },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        DecimalPipe,
        provideAnimations()
      ]
    })
      .catch(err => console.error(err));

  } catch (error) {
    console.error(error);
  }
}

function configFailed() {
  console.error('Error retrieving config.json');
}
